/**
 *
 * NotFoundPage
 *
 */

import React, { memo, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
// import { messages } from './messages';
import Logo from 'assets/images/Logo.svg';
import NoConnection from 'assets/images/NoConnection.webp';
import { Button } from 'core/components/Button/Loadable';
import History from 'core/utils/history';
import { resetLocalStorage } from 'features/Authentication/slice/saga';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'controller/types';
import { getDateAndTime } from 'core';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { useAuthenticationSlice } from 'features/Authentication/slice';
import axios from 'axios';
import moment from 'moment-timezone';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';

interface Props { }

export const LeftComponent = () => {
  return (
    <div className="col-span-4 h-[100vh] bg-primary-main">
      <div className="w-full py-[4%] h-[20%]">
        <img src={Logo} alt="LOGO" className="h-[80%] ml-[5%]" />
      </div>
      <div className="w-full h-[80%] flex items-center">
        <img src={NoConnection} alt="Some Error Occured" />
      </div>
    </div>
  );
};

export const DateErrorPage = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let cancelTokenSource: any;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const state: any = useSelector((state: RootState) => state.authentication);
  const { actions } = useAuthenticationSlice();
  const authData = useAuth();

  // const [type, settype] = React.useState<string>('Go Back');
  const timeZone = state?.authData?.TIME_ZONE || 'Asia/Kolkata' /* 'America/Whitehorse' */;
  const { date, hours, minutes } = getDateAndTime(timeZone);

  // useEffect(() => {
  //   if (EncryptedStorage.getItem('_UFT_') === null) {
  //     History.navigate('/');
  //     settype('Login');
  //   }
  // }, []);

  return <div className="grid grid-cols-12 h-[100vh]">
    <LeftComponent />
    <div className="col-span-8 h-[100vh] bg-[url('/src/features/Authentication/assets/BackGroundAuth.webp')] bg-cover">
      <div className="w-full h-full px-[15%] py-[22.5%]">
        {/* <h1 className="font-bold text-9xl mb-[4%]"></h1> */}
        <p className="font-regular text-neutral-60 text-4xl">
          Oooops, Your Computer Clock is Wrong
        </p>
        <p className="text-xl my-[4%] font-extralight text-neutral-60">
          Please fix your computer clock. {"(Expected datetime:"} <span className='font-bold'>{date} {hours}:{minutes}</span>)
        </p>
        <p className="text-xl my-[4%] font-extralight text-neutral-60">
          Org timezone: <span className='font-bold'>{timeZone}</span>. Your current timezone: <span className='font-bold'>{moment.tz.guess()}</span>
        </p>
        {!state.isLoggingOut ? <Button
        button={true}
          type="primary"
          label={"Go Back"}
          // TODO - Add Back to History
          onClick={e => {
            e.preventDefault();
            if (typeof cancelTokenSource != typeof undefined) {
              cancelTokenSource.cancel();
            }
            cancelTokenSource = axios.CancelToken.source();
            authData?.USER_LOGIN_ID &&
              dispatch(
                actions.logoutStart({
                  USER_LOGIN_ID: authData?.USER_LOGIN_ID,
                  cancelToken: cancelTokenSource,
                }),
              );
          }
          }
        /> : <div className='w-20'><SetupLoader width="w-12" height="h-12" /></div>}
      </div>
    </div>
  </div>
});

const Div = styled.div``;
